module.exports = __webpack_public_path__ + "img/staff.cb716686.svg";